import { Icon, makeStyles, Text } from '@rneui/themed'
import React, { useState } from 'react'
import { Modal, Pressable, View } from 'react-native'

interface Props {
  message?: string
}

export function ShiftAmountExplanationMessageView(props: Props) {
  const [modalVisible, setModalVisible] = useState(false)
  const styles = useStyles()

  return (
    <View>
      <Icon
        name="information-circle-outline"
        type="ionicon"
        size={14}
        onPress={() => setModalVisible(true)}
      />
      <Modal animationType="fade" transparent={true} visible={modalVisible}>
        <Pressable
          onPress={() => setModalVisible(false)}
          style={styles.modalBackDrop}
        >
          <View style={styles.container}>
            <View style={styles.modalView}>
              <Text style={styles.modalText}>{props.message}</Text>
            </View>
          </View>
        </Pressable>
      </Modal>
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 20,
  },
  modalView: {
    margin: 10,
    backgroundColor: theme.colors?.grey5,
    borderRadius: 20,
    padding: 25,
    alignItems: 'center',
    shadowColor: theme.colors?.black,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  modalBackDrop: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.50)',
  },
  modalText: {
    textAlign: 'center',
    fontSize: 16,
    color: theme.colors?.black,
  },
}))
